import PazienteDispositivi from "../";

const routes = [
    { name: "PazienteDeviceList", path: "/paziente/hassistokits", component: PazienteDispositivi.PazienteDeviceList, meta: { title: "patient.menu.lblKits" } },
    { name: "PazienteDeviceEdit", path: "/paziente/hassistokits/edit/:id", component: PazienteDispositivi.PazienteDeviceEdit, meta: { title: "kit da assegnare" } },
];

export default routes;
